import React from "react";
import MappedText from "../mapText"; 

export function Title({ field1, field2, field3, field4, dataType }) {
    const getTitle = () => {
        if (dataType === "variant" || dataType === "fusion") {
            if (field1 && field2) {
                return <b><MappedText text={field1}/> ({field2}): {field3}</b>;
            } else {
                return <b><MappedText text={field1}/>: {field3}</b>;
            }
        } 
        else {
                return field2 ? <b><MappedText text={field1}/> ({field2})</b> : <b><MappedText text={field1}/></b>;
            }
        };
    
    return getTitle();
}